/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import Feature from '@modules/utils/feature'

import { authorizeSaasOauthTokenRequest } from '@/apps/userconsole/reducers/registry'
import { getLoginRequest } from '@/reducers/asyncRequests/registry'

import {
  resetAuthorizeSaasOauthTokenRequest,
  checkForOktaAndHandleLogin,
} from '../../../actions/auth'
import { isFeatureActivated } from '../../../selectors'

import PasswordBasedLogin from './PasswordBasedLogin'

import type { ThunkDispatch } from '@/types/redux'
import type { StateProps, DispatchProps, ConsumerProps } from './types'

const mapStateToProps = (state): StateProps => ({
  loginRequest: getLoginRequest(state),
  authorizeSaasOauthTokenRequest: authorizeSaasOauthTokenRequest(state),
  registrationButtons: isFeatureActivated(state, Feature.registrationButtons),
  isGovCloud: isFeatureActivated(state, Feature.hideIrrelevantSectionsFromGovCloud),
})

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  resetAuthorizeSaasOauthTokenRequest: () => dispatch(resetAuthorizeSaasOauthTokenRequest()),
  onMfaSuccess: (args) => dispatch(checkForOktaAndHandleLogin(args)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordBasedLogin)
